// ============================================================================
// note-client-mod -- useNoteStats Hook
//
// 获取笔记统计 + 标签聚合（用于标签云/过滤下拉）。
// ============================================================================
import { useState, useEffect, useCallback } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useNoteStats() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchStats = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getNoteApiClient().getStats();
            setStats(result);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '获取统计失败');
            setStats(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchStats();
    }, [fetchStats]);
    return { stats, loading, error, refresh: fetchStats };
}
//# sourceMappingURL=use-note-stats.js.map